"use strict";

var _ = require("underscore");
var TeamActions = require("../actions/team-actions.js");

var TeamStore = Reflux.createStore({
  state: {
    teams: []
  },
  storeState: function(state){
    this.trigger(this.state);
    return this.state;
  },
  getInitialState: function() {
    return {
      teams: []
    };
  },
  init: function(){
    this.listenTo(TeamActions.getTeams.completed, this.handleGetTeamCompleted);
    this.listenTo(TeamActions.addTeam.completed, this.handleAddTeamCompleted);
    this.listenTo(TeamActions.deleteTeam.completed, this.handleDeleteTeamCompleted);
    this.listenTo(TeamActions.editTeam.completed, this.handleEditTeamCompleted);
    this.listenTo(TeamActions.getTeams.error, this.handleError);
    this.listenTo(TeamActions.addTeam.error, this.handleError);
    this.listenTo(TeamActions.deleteTeam.error, this.handleError);
    this.listenTo(TeamActions.editTeam.error, this.handleError);
    this.state = this.getInitialState();
  },

  handleGetTeamCompleted: function(body, teams) {
    this.state.teams = teams;
    this.trigger(this.state);
  },

  handleDeleteTeamCompleted: function(body, deletedTeam) {
    this.state.teams = _.map(this.state.teams, function(team) {
      if (team.id != deletedTeam.id) {
        return team;
      } else {
        return;
      }
    });

    this.state.teams = _.compact(this.state.teams);

    this.trigger(this.state);
  },

  handleEditTeamCompleted: function(body, editedTeam) {
    this.state.teams = _.map(this.state.teams, function(team) {
      if (team.id == editedTeam.id) {
        return editedTeam;
      } else {
        return team;
      }
    });

    this.trigger(this.state);
  },

  handleAddTeamCompleted: function(body, addedTeam) {
    this.state.teams.push(addedTeam);

    this.trigger(this.state);
  },

  handleError: function(body, response) {

  }
});

module.exports = TeamStore;



// WEBPACK FOOTER //
// ./app/screens/Team/stores/team-store.js